import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TextField,
} from "@mui/material";
import { Regexes } from "../../core/Regexes";

export default function UpdateInventoryModal({ open, onClose, order }) {
    const [rows, setRows] = useState([]);

    useEffect(() => {
        if (open && order) {
            const shippedDict = order.receivedShipments.reduce((acc, s) => {
                acc[s.productId] = (acc[s.productId] || 0) + s.quantity;
                return acc;
            }, {});

            setRows(
                order.serviceItems.map((item) => ({
                    productId: item.productId,
                    description: item.description,
                    originalQty: item.quantity,
                    shippedQty: shippedDict[item.productId] || 0,
                    newQty: Math.max(
                        0,
                        item.quantity - (shippedDict[item.productId] || 0)
                    ),
                }))
            );
        }
    }, [open, order]);

    const handleQtyChange = (idx, val) => {
        if (val !== "" && !Regexes.OnlyNumeric.test(val)) {
            const fixedVal = val.slice(0, -1);
            setRows((prev) =>
                prev.map((r, i) =>
                    i === idx
                        ? { ...r, newQty: fixedVal === "" ? 0 : Number(fixedVal) }
                        : r
                )
            );
        } else {
            setRows((prev) =>
                prev.map((r, i) =>
                    i === idx ? { ...r, newQty: val === "" ? 0 : Number(val) } : r
                )
            );
        }
    };

    const handleSave = () => {
        const editedItems = rows.map(({ productId, newQty }) => ({
            productId,
            quantity: Number(newQty),
        }));
        onClose(true, editedItems);
    };

    return (
        <Dialog
            open={open}
            onClose={() => onClose(false)}
            maxWidth="md"
            fullWidth
            className="font-size-14"
        >
            <DialogTitle>Update Inventory – {order?.id}</DialogTitle>

            <DialogContent dividers>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Description</TableCell>
                            <TableCell align="right">Ordered Qty</TableCell>
                            <TableCell align="right">Shipped Qty</TableCell>
                            <TableCell align="right" sx={{ width: 160 }}>
                                Edit Qty
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {rows.map((row, idx) => (
                            <TableRow key={row.productId}>
                                <TableCell>{row.description}</TableCell>
                                <TableCell align="right">{row.originalQty}</TableCell>
                                <TableCell align="right">{row.shippedQty}</TableCell>

                                <TableCell align="right">
                                    <TextField
                                        size="small"
                                        value={row.newQty}
                                        inputProps={{
                                            min: 0,
                                            max: 5,
                                            step: 1,
                                            inputMode: "number",
                                        }}
                                        onChange={(e) => handleQtyChange(idx, e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === "." || e.key === ",") {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </DialogContent>

            <DialogActions>
                <Button
                    variant="contained"
                    className="btn btn-primary"
                    onClick={() => onClose(false, null)}
                >
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    className="btn btn-primary"
                    onClick={handleSave}
                >
                    Update
                </Button>
            </DialogActions>
        </Dialog>
    );
}
